<template>
  <div class="page-content">
    <slot></slot>
  </div>
</template>

<script>
export default {
    name: 'PageContent',
    props: {
      'index': {
        type: Number,
        default: 1,
      }
    },
}
</script>

<style lang="scss">
  .page-content {
    padding: 10px 135px;
    display: flex;
    align-items: center;

    &.batch-edit-wrapper {

      .panel-v2 {

        .title-line {
          border: none;
        }

        .divider {
          margin: 16px 0 32px;
        }

        .form-title {
          font: normal normal normal 16px/24px Nunito-bold;
          letter-spacing: 0px;
          color: #004EA8;
          margin: 0 0 16px;
        }
      }
    }

    .divider {
      border: none;
      border-bottom: 1px solid #E4E4E4;
      width: 100%;
    }

    .steps {
      margin: 0;
    }

    &.summary-page, &.batch-edit-wrapper {

      flex-direction: column;

      .summary-title {
        align-self: start;
        width: 100%;
        text-align: left;
        font: normal normal normal 20px/24px Nunito-bold;
        letter-spacing: 0px;
        color: #2E2E2E;
        margin: 38px 0 0;
      }

      .with-two-panel {
        display: flex;
        justify-content: space-between;
        width: 100%;

        .panel-v2.content-area {
          margin: 24px 0;
        }

      }

      .summary-el-button-line {
        display: flex;
        width: 100%;
        height: 112px;
        background: #FFFFFF 0% 0% no-repeat padding-box;
        box-shadow: 0px 0px 16px #00000014;
        border-radius: 16px;
        justify-content: center;
        align-items: center;
      }
    }

    &.batch-edit-wrapper {
      .summary-title {
        padding-left: 145px;
      }
    }

  }
</style>